import { CurrentSelection } from 'lib/ecommerce/lego/Tc.Module.LegoContainer';

/**
 * The available parameter options. All of which are required.
 */
export interface Params {
	// The url the lead is being called from. If possible a deeplink to the current state of the page.
	cancelUrl : string;
	mode? : '4P_Wireline' | '4P_Wireless';
	leadProductGroup : 'WIRELESS' | 'WIRELINE';
	productSegment : 'RES' | 'SME';
	// The array of products has to be serialized as such: type,name|type,name
	productInfo : Product[];
	returnUrl : string | Params;
}

export interface Product {
	type : ProductType;
	value : string;
}

/**
 * The available product types
 */
export const enum ProductType {
	Bundle = 'BUNDLE',
	Tv = 'TV',
	Voip = 'VOIP',
	Internet = 'INTERNET',
	Service = 'SERVICE',
	Device = 'DEVICE',
	AboLength = 'ABOLENGTH',
	RatePlan = 'RATEPLAN',
}

/**
 *
 * @param baseUrl 	The `baseUrl`
 * @returns			The default return url on top of `baseUrl`
 */
export function getDefaultReturnUrl(baseUrl : string) {
	return baseUrl + '/homescreen/online/homeScreen.html';
}

/**
 * @param products	The array of products.
 * @returns 		A serialize string as such: type,name|type,name|etc...
 */
function getProductInfo(products : Product[]) {
	return products.map(product => `${product.type},${product.value}`).join('|');
}

/**
 * @param params		The `params` object to serialize into a url search string
 * @param baseUrl		The base for the resutling url onto which to append the params string
 * @returns				A valid URL including the `params` as GET parameters
 */
export function stringifyParams(params : Params, baseUrl = '') : string | null {
	if(!params || !params.productInfo || params.productInfo.length === 0) {
		return null;
	}

	const resultPath = '/lmneo/online/?leadType=PRODUCT&system=PORTAL&';

	const paramString = Object.keys(params).sort().map(key => {
		let value = params[key as keyof Params];

		if(!value) {
			return undefined;
		}

		if(typeof value !== 'string') {
			if(Array.isArray(value)) {
				value = getProductInfo(params.productInfo);
			} else {
				value = stringifyParams(value, baseUrl) || '';
			}
		}

		return `${key}=${encodeURIComponent(value)}`;
	}).filter(Boolean).join('&');

	return baseUrl + resultPath + paramString;
}


/**
 * Returns an array of inOne Home products based off the users current inOne Home configuration.
 * inOne Home does not include mobile or a mobile device.
 *
 * @param currentSelection	The users current selection
 * @returns					An array of products
 */
export function getInOneHomeProducts(currentSelection : CurrentSelection) : Product[] {
	const products : Product[] = [];

	Object.keys(currentSelection).sort().forEach(key => {
		const val = currentSelection[key as keyof CurrentSelection];

		if(!val || !val.slideId) {
			return;
		}

		switch(key.toUpperCase()) {
			case ProductType.Internet:
				products.push({type: ProductType.Internet, value: val.slideId});
				break;
			case ProductType.Voip:
				products.push({type: ProductType.Voip, value: val.slideId});
				break;
			case ProductType.Tv:
				products.push({type: ProductType.Tv, value: val.slideId});
				break;
			case ProductType.Service:
				products.push({type: ProductType.Service, value: val.slideId});
				break;
			default:
				return;
		}
	});

	return products;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/leadmanagement/helpers.ts